import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import {
  serverLoadOrganizations,
  setOrganizationFilterCountry,
  setOrganizationFilterSearchTerm,
} from '../actions';

import { Input, Select, Button } from 'antd';

import _ from 'lodash';

import { sortByNameAsc } from "../utils"

const iconStyles = {
  marginLeft: 4,
  color: 'rgba(10,10,10,0.4)',
};

const countryOptions = [
  { key: 'AU', value: 'AU', text: 'Australia' },
  { key: 'NZ', value: 'NZ', text: 'New Zealand' },
	{ key: 'SG', value: 'SG', text: 'Singapore' }
];

class OrganizationListItem extends Component {
  onSelect(e) {
    this.props.onClick();
    e.preventDefault();
  }
  render() {
    return (
      <div className="list-item" style={{
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 4,
        paddingRight: 4,
        marginBottom: 4,
        fontSize: 16,
      }}>
        <a href="" onClick={this.onSelect.bind(this)} style={{ color: 'rgba(10,10,10,0.9)' }}>
          <div>
            <small>{this.props.organization.name} {(
              <b style={iconStyles}>
                ({this.props.organization.livePOICount} / {this.props.organization.poiCount} POI LIVE)
              </b>
            )}</small>
          </div>
        </a>
      </div>
    )
  }
}

OrganizationListItem.propTypes = {
  active: PropTypes.bool,

  organization: PropTypes.shape({
    name: PropTypes.string,
    processed: PropTypes.bool,
    livePOICount: PropTypes.number,
    poiCount: PropTypes.number,
  }),

  onClick: PropTypes.func,
}

OrganizationListItem.defaultProps = {
  active: false,
}

class OrganizationsSidebar extends Component {
  componentDidMount() {
    this.props.loadOrganizations();
  }
  onCountryChange(value) {
    this.props.onCountryChange(value);
  }
  onSearchTermChange(e) {
    this.props.onSearchTermChange(e.target.value);
  }

  render() {
    var self = this;
    let activeOrganizationId = this.props.match.params.organization_id || null;

    const { props } = this;

    const filteredOrganizationIDs = this.props.organizationIDs.filter((organizationId) => {
      let organization = self.props.organizationsMap[organizationId];
      if ((organization.name === '' || organization.name.search(new RegExp(self.props.searchTerm, 'gi')) > -1)
        && (_.isNull(self.props.filterCountry) || organization.country === self.props.filterCountry)) {
        return true;
      }
      return false;
    });

    let orgs = filteredOrganizationIDs.map(organizationId => self.props.organizationsMap[organizationId]);
    orgs.sort(sortByNameAsc);

    return (
      <div>
        <div className="sidebar-info">
          <div className="sidebar-inner">
            <h4 className="heading-level-1">Organizations</h4>
            <div>
              <Input
                placeholder='Search...'
                style={{ marginBottom: 10 }}
                onChange={this.onSearchTermChange.bind(this)}
                value={this.props.searchTerm}
              />
              <Select placeholder='Country' dropdownMatchSelectWidth={true}
                onChange={this.onCountryChange.bind(this)}
                value={this.props.filterCountry}
                style={{ width: '100%' }}>
                {countryOptions.map((country) => (
                  <Select.Option key={country.key}>
                    {country.text}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div style={{ padding: '1em 0.5em'}}>
              {props.organizationsSummary[props.filterCountry] ? (
                <b>{props.organizationsSummary[props.filterCountry].livePOICount} / {props.organizationsSummary[props.filterCountry].count} Live</b>
              ): null}
            </div>
            <div style={{ padding: '10px 0px' }} >
              <Link to="/createOrganization">
                <Button icon="plus" type="primary" style={{
                  width: '100%',
                }}>
                  Create New Organization
                  </Button>
              </Link>
            </div>
          </div>
        </div>
        <div className="sidebar-inner">
          <div>
            {orgs.map((org) => {
              return (
                <OrganizationListItem
                  organization={org}
                  key={org._id}
                  onClick={() => {
                    this.props.history.push(`/organizations/${org._id}/pois`);
                  }}
                  active={(activeOrganizationId === org._id)}
                />
              )
            }
            )}
          </div>
        </div>
      </div>
    );
  }
}

OrganizationsSidebar.propTypes = {
  filterCountry: PropTypes.string,
  searchTerm: PropTypes.string,

  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  organizationIDs: PropTypes.array,
  organizationsSummary: PropTypes.object,

  match: PropTypes.shape({
    params: PropTypes.shape({
      'organization_id': PropTypes.string,
    })
  }),

  onSearchTermChange: PropTypes.func,
  onCountryChange: PropTypes.func,
  loadOrganizations: PropTypes.func,
}

OrganizationsSidebar.defaultProps = {
  organizationsIDs: []
}

// Map props to the store

const mapStateToProps = (state) => ({
  organizationIDs: state.routes.organizations.server.getIn(['organizationIDs']).toArray(),
  organizationsMap: state.routes.organizations.server.getIn(['organizationsMap']).toObject(),
  organizationsSummary: state.routes.organizations.server.getIn(['organizationsSummary']).toObject(),
  filterCountry: state.routes.organizations.filters.get('country'),
  searchTerm: state.routes.organizations.filters.get('searchTerm'),
});

const mapDispatchToProps = (dispatch) => ({
  loadOrganizations: () => {
    dispatch(serverLoadOrganizations());
  },
  onSearchTermChange: (searchTerm) => {
    dispatch(setOrganizationFilterSearchTerm(searchTerm));
  },
  onCountryChange: (country) => {
    dispatch(setOrganizationFilterCountry(country));
  },
});

const OrganizationsSidebarContainer = connect(mapStateToProps, mapDispatchToProps)(OrganizationsSidebar);

export default OrganizationsSidebarContainer;


// WEBPACK FOOTER //
// ./src/organizations/components/OrganizationsSidebar.js